import {
    Component, EventEmitter, Input, OnDestroy, OnInit,
    // Optional,
    Output
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {NGXLogger} from 'ngx-logger';
// import {
    // DialogService,
    // DynamicDialogConfig,
    // DynamicDialogRef} from 'primeng/dynamicdialog';
// import {ErrorDialogComponent} from '@cas-hub/acabim-common-client';
import {GroupService} from '../../../../../_services/group.service';
import {ProjectGroup} from '../../../../../_models/group.model';
import {Subscription} from 'rxjs';

@Component({
    selector: 'acabim-admin-groups-project-update',
    templateUrl: './update-project-group.component.html'
})
export class GroupProjectUpdateComponent implements OnInit, OnDestroy {

    @Input() public projectDetails: ProjectGroup = {
        id: '',
        lastModifiedDate: '',
        name: ''
    };
    @Output() completed = new EventEmitter<string>();
    loading = false;
    projectGroupForm: FormGroup | undefined;
    private _currentProcess: Subscription = new Subscription();

    constructor(
        private readonly logger: NGXLogger,
        private groupService: GroupService
    ) {}

    ngOnInit(): void {
        console.dir(this.projectDetails);
        this.projectGroupForm = new  FormGroup({
            projectGroupName: new FormControl(this.projectDetails?.name),
            projectGroupId: new FormControl(this.projectDetails?.id)
        });
    }

    onProjectGroupUpdateSubmit(): void {
        this.upsertProjectGroup();
    }

    private upsertProjectGroup(): void {
        this.loading = true;
        this.logger.debug('[GroupProjectUpdateComponent] Updating existing project group: ' + this.projectGroupForm?.value.projectGroupId);
        this._currentProcess = this.groupService.upsertProjectGroup(
            this.projectGroupForm?.value.projectGroupName,
            this.projectGroupForm?.value.projectGroupId
        ).subscribe(newProjectGroup => {
            this.logger.debug('[GroupProjectUpdateComponent] Project group updated successfully: ' + newProjectGroup.id);
            this.completed.emit('updated');
            this.loading = false;
        }, (error: any) => {
            this.logger.debug('[GroupProjectUpdateComponent] Project group failed to update');
            this.logger.error(error);
            this.loading = false;
        });
    }

    onUpdate(update: boolean) {
        if (update) {
            this.completed.emit('update');
        }
    }

    onCancel(): void {
        this.logger.debug('[GroupProjectUpdateComponent] Update Project Group Modal Cancelled');
        this.completed.emit('cancelled');
    }

    ngOnDestroy(): void {
        this._currentProcess.unsubscribe();
    }
}
